import React from "react";
import cn from "classnames";
import { usePillNavigationHook } from "./use-pill-navigation-hook";
import styles from "./pill-navigation.module.scss";

interface PillNavigationOptionTypes {
  name: string;
  link: string;
  render: boolean;
}

interface PillNavigationPropTypes {
  options: PillNavigationOptionTypes[];
  activeView: string;
  border?: boolean;
  onChangeCallback: (value: string) => void;
}

const cssClassName = "pill-navigation";

export const PillNavigation = ({
  options,
  activeView,
  border,
  onChangeCallback,
}: PillNavigationPropTypes) => {
  const {
    containerRef,
    backgroundStyle,
    buttonRefs,
    selectedIndex,
    firstRenderTransition,
    handleClick,
  } = usePillNavigationHook(options, activeView, onChangeCallback);

  return (
    <div
      className={cn(styles[cssClassName], {
        [styles[`${cssClassName}--border`]]: border,
      })}
      ref={containerRef}
    >
      <div
        className={styles[`${cssClassName}__selected-background`]}
        style={{
          width: `${backgroundStyle.width}px`,
          left: `${backgroundStyle.left}px`,
          transition: firstRenderTransition(),
        }}
      />
      {options.map(
        (option, index) =>
          option.render && (
            <button
              key={option.link}
              ref={(el) => (buttonRefs.current[index] = el)}
              className={cn(styles[`${cssClassName}__button`], {
                [styles[`${cssClassName}__button--selected`]]:
                  selectedIndex === index,
              })}
              onClick={() => handleClick(index, option.link)}
            >
              {option.name}
            </button>
          ),
      )}
    </div>
  );
};
